export const ImageType = {
  LANDSCAPE: "landscape",
  FULL_LOGO: "logo_full",
  THUMBNAIL: "logo_thumbnail",
  SEAL: "seal",
};
export const AlternativeImage = {
  INSTITUTION_LOGO:
    "https://s3.us-east-2.amazonaws.com/academic.online/default_photos/default_institution_photo.png",
  INSTITUTION_SEAL:
    "https://t4.ftcdn.net/jpg/05/26/52/11/360_F_526521105_hNPxIZsrIush3tB1vrQYqcX7yJWfptog.jpg",
  FACULTY_AVATAR:
    "https://s3.us-east-2.amazonaws.com/academic.online/default_photos/default_faculty_photo.png",
  INSTITUTION_LANDSCAPE: null,
  VENUE_LOGO:
    "https://s3.us-east-2.amazonaws.com/academic.online/default_photos/default_venue_photo.png",
};
export const ImageCheckType = {
  INSTITUTION_LOGO: "INSTITUTION_LOGO",
  INSTITUTION_SEAL: "INSTITUTION_SEAL",
  INSTITUTION_LANDSCAPE: "INSTITUTION_LANDSCAPE",
  FACULTY_AVATAR: "FACULTY_AVATAR",
};
export const SkeletonType = {
  IMAGE: "IMAGE",
  PARAGRAPH: "PARAGRAPH",
  IMAGE_WITH_PARAGRAPH: "IMAGE_WITH_PARAGRAPH",
  INPUT: "INPUT",
};
